import { memo, type PropsWithChildren } from 'react';

import { type IconType } from '~/types/icons';

export type KeyShortcutProps = {
  icon?: IconType;
  text?: string;
};

export const KeyShortcut = memo(({ icon: Icon, text, children }: PropsWithChildren<KeyShortcutProps>) => (
  <div className="flex items-center justify-between py-2">
    <div className="flex items-center">
      {!!Icon && <Icon className="size-4 ads:text-icon-default text-gray-10" />}
      {!!text && <div className="ml-2 ads:text-secondary text-14 text-gray-11">{text}</div>}
    </div>
    <div className="flex [&>div]:ml-0.5">{children}</div>
  </div>
));

KeyShortcut.displayName = 'KeyShortcut';
